import "./FieldSet_module.css";
const FieldSet_module = {
    fieldSet: "fieldSet__11c0a978addf77b2",
    fieldsetContent: "fieldsetContent__11c0a978addf77b2",
    label: "label__11c0a978addf77b2",
    defaultSpacing: "defaultSpacing__11c0a978addf77b2",
    fieldSetLabelTypography: "fieldSetLabelTypography__11c0a978addf77b2"
};
export { FieldSet_module as default };
